module.exports = __webpack_public_path__ + "static/primary-stacked-white-7c944c90091de67aa014e548ed8bc759.png";